import React from 'react';
import cn from 'classnames';
import { FilterCheckIconSvg } from 'apps/sigma2-ui/src/filters-v2/components/FilterCheckIcon';

export interface FilterCheckboxIconProps {
  /**
   * The checked state of the checkbox
   */
  checked: boolean;

  /**
   * The hovered state of the checkbox
   */
  hovered: boolean;
}

export const FilterCheckboxIcon = ({
  checked,
  hovered,
}: FilterCheckboxIconProps) => {
  return (
    <span
      className={cn('inline-block p-[3px] w-6 h-6 rounded-[2px]', {
        'bg-royal-200': hovered,
        'bg-transparent': !hovered,
      })}
    >
      <span
        className={cn(
          'flex w-full h-full border-[2px] border-gray-900 rounded-[2px]',
          {
            'bg-gray-900': checked,
            'bg-white': !checked,
          },
        )}
      >
        {checked && (
          <FilterCheckIconSvg
            svg={{
              className: 'w-full h-full text-white',
            }}
          />
        )}
      </span>
    </span>
  );
};
